module.exports = __webpack_public_path__ + "img/palm6.2c624615.png";